import React from "react";
import { motion } from "framer-motion";
import "./ContactBanner.css";

function ContactBanner() {
  const handleScroll = () => {
    const section =
      document.getElementById("contact") ||
      document.getElementById("contact-section");
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="contact-banner">
      <div className="overlay"></div>
      <motion.div
        className="contact-banner-content"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="banner-left">
          <h2 className="banner-title">
            Get In Touch Today For Expert Automotive Forensics & Diagnostics!
          </h2>
          <p className="banner-info">
            <strong>Call Us Now:</strong>{" "}
            <span className="highlight">
              <a href="tel:+447501911970">+44 7501 911970</a>
            </span>
          </p>
          <p className="banner-info">
            <strong>Email:</strong>{" "}
            <span className="highlight">
              <a href="mailto:carforensicsltd@gmail.com">carforensicsltd@gmail.com</a>
            </span>
          </p>
        </div>

        <div className="banner-right">
          <button className="contact-btn" onClick={handleScroll}>
            Contact Us
          </button>
        </div>
      </motion.div>
    </section>
  );
}

export default ContactBanner;
